import { Box, Typography } from "@mui/material";
import PageNotFoundImage from "../../assets/images/Icons/503.svg";

export const PageServiceUnavailable = () => {
  return (
    <Box
      sx={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        padding: 3,
        height: "100vh",
      }}
    >
      <Box
        sx={{
          alignItems: "center",
          display: "flex",
          flexDirection: "column",
        }}
      >
        <Typography align="center" color="textPrimary" variant="h3">
          503: Service Unavailable
        </Typography>
        <Typography align="center" color="textSecondary" variant="subtitle2">
          The service is temporarily unavailable. This might be a system issue,
          or maintenance.
          <br /> Try again later or return to the main dashboard.
        </Typography>
        <Box sx={{ textAlign: "center" }}>
          <img
            alt="Under development"
            src={PageNotFoundImage}
            style={{
              marginTop: 50,
              display: "inline-block",
              maxWidth: "100%",
              width: 350,
            }}
          />
        </Box>
      </Box>
    </Box>
  );
};
